<template>
  <div id="customer-account-credit-home">
    <div  class="vx-row mb-4">
      <div class="vx-col w-full">
        <vx-card  title="ACCOUNT CREDIT" class="pb-4" v-can="'view-account-credit'">
          <template slot="actions">
            <vs-button v-can="'create-edit-account-credit'" v-if="!isDataAvailable"  @click="onClickCreateAccountCredit" class="mr-4" color="primary" type="filled">
              Set up credit or proforma account
            </vs-button>
          </template>
          <ValidationObserver ref="form" v-slot="{ handleSubmit }" v-if="isDataAvailable">
            <form  @submit.prevent="handleSubmit(clickOnUpdateCreditAccount)" autocomplete="off">
              <div class="vx-row mb-3" v-if="accountCredit.account_type !== 'proforma'">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider vid="credit_limit" name="credit_limit" :rules="requiredAndTwoDecimalRules" v-slot="{ errors }">
                    <small class="label">Credit Limit</small>
                    <vx-input-group class="">
                      <template slot="prepend">
                        <div class="prepend-text bg-success">
                          <span>{{account_currency}}</span>
                        </div>
                      </template>
                      <vs-input readonly v-model="accountCredit.credit_limit"   name="credit_limit" class=" required" label=""/>
                    </vx-input-group>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider vid="current_credit_amount" name="current_credit_amount" :rules="requiredAndTwoDecimalRules" v-slot="{ errors }">
                    <small class="label">Current Credit Balance</small>
                    <vx-input-group class="">
                      <template slot="prepend">
                        <div class="prepend-text bg-success">
                          <span>{{account_currency}}</span>
                        </div>
                      </template>
                      <vs-input readonly v-model="accountCredit.current_credit_amount"   name="current_credit_amount" class="w-full required" label=""/>
                    </vx-input-group>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-row mb-3">
                <div v-if="accountCredit.account_type !== 'proforma'" class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider vid="available_credit" name="available_credit" rules="required" v-slot="{ errors }">
                    <small class="label">Available Credit Balance</small>
                    <vx-input-group class="">
                      <template slot="prepend">
                        <div class="prepend-text bg-success">
                          <span>{{account_currency}}</span>
                        </div>
                      </template>
                      <vs-input readonly v-model="accountCredit.available_credit"   name="available_credit" class="w-full required" label=""/>
                    </vx-input-group>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider vid="account_type" name="account_type" rules="" v-slot="{ errors }">
                    <small class="label">Account Type</small>
                    <v-select :clearable="false" placeholder="" v-model="accountCredit.account_type"  :options="['proforma','credit']" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-row mb-3" v-if="accountCredit.account_type === 'credit'">
                <div class="vx-col md:w-1/2 w-full md:mb-0">
                  <ValidationProvider vid="credit_account_type" name="credit_account_type" rules="" v-slot="{ errors }">
                    <small class="label">Credit Account Type</small>
                    <v-select :clearable="false" placeholder="" v-model="accountCredit.credit_account_type"
                              :options="[{name: 'Standard', value: 'Standard'}, { name: 'EOM (End of Month)', value: 'EOM' }]"
                              :reduce="option => option.value"
                              label="name"
                              :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="vx-col md:w-1/2 w-full md:mb-0" v-if="['EOM', 'Standard'].includes(accountCredit.credit_account_type)">
                  <ValidationProvider vid="credit_terms" name="credit_terms" rules="required" v-slot="{ errors }">
                    <small class="label">Credit Terms</small>
                    <vx-input-group class="">
                      <template slot="prepend">
                        <div class="prepend-text bg-success">
                          <span>Days</span>
                        </div>
                      </template>
                      <vs-input v-model="accountCredit.credit_terms"   name="credit_terms" class="w-full required" label=""/>
                    </vx-input-group>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col w-full">
                  <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                    <small class="label">Note</small>
                    <vs-textarea class="mb-0" v-model="accountCredit.note" height="100px" />
                  </ValidationProvider>
                </div>
              </div>

              <div class="flex flex-wrap items-center justify-end mt-8">
                <vs-button v-can="'create-edit-account-credit'" button="submit" class="ml-auto mt-2">Save Changes</vs-button>
<!--                <vs-button @click="accountCredit = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
              </div>

            </form>
          </ValidationObserver>
        </vx-card>
      </div>
    </div>

<!--    <customer-credit-note-list v-bind:account_currency="account_currency"/>-->
    <customer-account-limit-request 
      v-bind:account_currency="account_currency" 
      v-on:creditApproved="onCreditApproved"
      v-bind:account_type="accountCredit.account_type"
    />


    <create-customer-account-credit-pop-up v-bind:account_currency="account_currency" ref="createCustomerAccountCreditPopUp" />
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const CustomerRepository = RepositoryFactory.get('customer')
  import CustomerAccountLimitRequest from './CustomerAccountLimitRequest.vue'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import CreateCustomerAccountCreditPopUp from '@/components/popups/customer/account-credit/CreateCustomerAccountCreditPopUp'
  import CustomerCreditNoteList from "@/views/pages/customer-manage/CustomerDetailsGeneral/CustomerCreditNoteList";


  export default {
    name: 'AllUsersList',
    props: {
      account_currency  : {
        type: String,
        default: '',
      }
    },
    data () {
      return {
        customerId: '',
        accountCredit: {},
        isDataAvailable: false
      }
    },
    components: {
      'v-select': vSelect,
      CustomerAccountLimitRequest,
      CreateCustomerAccountCreditPopUp,
      CustomerCreditNoteList
    },
    mixins : [SuccessMessage, ErrorMessages],
    async mounted () {
      this.customerId = this.$route.params.id
      await this.fetchCustomerAccountCredit()
    },
    methods: {
      async refreshData () {
        await this.fetchCustomerAccountCredit()
      },

      async fetchCustomerAccountCredit(){
        await this.$vs.loading({
          container: '#customer-account-credit-home',
          scale: 0.45
        })
        try {
          const {data} = await CustomerRepository.getCustomerAccountCredit(this.customerId)
          this.accountCredit = data.data
          this.isDataAvailable = true
        } catch (e) {
          // this.convertAndNotifyError(e)
          this.isDataAvailable = false
        }
        this.$vs.loading.close('#customer-account-credit-home > .con-vs-loading')
      },
      async clickOnUpdateCreditAccount() {
        const vue = this;
        this.$vs.loading()
        try {
          this.accountCredit.credit_limit = (Number(this.accountCredit.credit_limit)).toFixed(2)
          this.accountCredit.current_credit_amount = (Number(this.accountCredit.current_credit_amount)).toFixed(2)
          await CustomerRepository.updateCustomerAccountCredit(this.customerId, this.accountCredit)
          this.showSuccessMessage('Account credit updated successfully')
          await this.fetchCustomerAccountCredit()
        }catch (e) {
          this.$vs.loading.close()
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickCreateAccountCredit() {
        await this.$refs.createCustomerAccountCreditPopUp.openPopup(this.customerId)
      },
      async onCreditApproved() {
        await this.fetchCustomerAccountCredit()
      }
    },
    watch : {

    },
    computed: {
      requiredAndTwoDecimalRules() {
        if (this.accountCredit.account_type === 'proforma') {
          return ''
        } else {
          return 'required'
        }
      }
    }
  }
</script>


<style scoped>

</style>
